import useAuth from "hooks/useAuth";
import { useCallback } from "react";
import useRouter from "common/hooks/use-router";
import CrudEdit from "common/components/Crud/CrudEdit";
import UserForm from "./UserForm";

function MyAccountForm() {
  const router = useRouter();
  const { user } = useAuth();

  const back = useCallback(() => {
    router.navigate("/users");
  }, [router]);

  return user?.id ? (
    <CrudEdit
      collectionName="users"
      id={user.id}
      Form={UserForm}
      onBack={back}
    />
  ) : null;
}

export default MyAccountForm;
